import rootStore from './rootStore';

export default rootStore;
